'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Paragraph = require('@narvar/nth-bit-paragraph');
var useAnalytics = require('../../../../common/providers/useAnalytics.js');
var useTitanAnalytics = require('../../../../common/providers/titan/useTitanAnalytics.js');
var ViewWrapper = require('../../components/ViewWrapper.js');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var useOrderLookupForm = require('../../../../common/views/OrderLookup/useOrderLookupForm.js');
var Loading = require('../../../../common/components/Loading.js');
var Spacer = require('../../../../common/views/OrderLookup/Spacer.js');
var ErrorBanner = require('../../../../common/components/ErrorBanner.js');
var Button = require('@narvar/nth-block-button');
var OrderNumberField = require('../../../../common/views/OrderLookup/fields/OrderNumberField.js');
var EmailField = require('../../../../common/views/OrderLookup/fields/EmailField.js');
var ClaimReasonField = require('../../../../common/views/OrderLookup/fields/ClaimReasonField.js');
var nthBitHeader = require('@narvar/nth-bit-header');
var useEligibilityQuery = require('./useEligibilityQuery.js');
var AgentNavigatorProvider = require('../../providers/AgentNavigatorProvider.js');
var IframeHeight = require('../../components/IframeHeight.js');
var SessionContext = require('../../../../common/providers/SessionContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);

const OrderLookup = () => {
  const logEvent = useAnalytics["default"]();
  const titan = useTitanAnalytics["default"]();
  const {
    claimTypeOptionActions
  } = nthHookSettings.useSettings();
  const {
    claimsButtonNext,
    claimsOrderLookupTitle,
    claimsOrderLookupLoading,
    claimsOrderLookupReasonDescription,
    claimsOrderLookupApiErrorOrderNotFound,
    claimsOrderLookupApiErrorUnknown
  } = nthHookTranslations.useTranslations();
  const {
    onSubmit,
    onChange,
    values,
    errors,
    submitEnabled,
    apiErrorMessage,
    loading
  } = useOrderLookupForm["default"]({
    useEligibilityQuery: useEligibilityQuery["default"],
    claimTypeOptionActions: claimTypeOptionActions ?? {},
    apiErrorMessages: {
      claimsOrderLookupApiErrorOrderNotFound: claimsOrderLookupApiErrorOrderNotFound ?? '',
      claimsOrderLookupApiErrorUnknown: claimsOrderLookupApiErrorUnknown ?? ''
    }
  });
  const {
    orderNumber
  } = SessionContext.useSession();
  const {
    navigateToOrderOverview
  } = AgentNavigatorProvider.useAgentNavigator();
  React.useEffect(() => {
    // Note: This effect is only called on first component render
    titan === null || titan === void 0 ? void 0 : titan.page({
      name: 'Order Lookup'
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.PAGE_LOAD,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ORDER_LOOKUP,
      page_step: useAnalytics.ClaimsPageStep.ORDER_LOOKUP
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(IframeHeight["default"], null, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      maxWidth: '23rem',
      margin: '0 auto'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Loading["default"], {
    loading: loading,
    text: claimsOrderLookupLoading || ''
  }, /*#__PURE__*/React__default["default"].createElement("form", {
    noValidate: true,
    onSubmit: onSubmit
  }, /*#__PURE__*/React__default["default"].createElement(ViewWrapper["default"], {
    contentScrollable: false,
    dismissButton: {
      onClick: () => navigateToOrderOverview()
    },
    bottomButton: {
      type: Button.ButtonType.submit,
      disabled: !submitEnabled,
      children: claimsButtonNext
    }
  }, apiErrorMessage && /*#__PURE__*/React__default["default"].createElement(Spacer["default"], null, /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, apiErrorMessage)), /*#__PURE__*/React__default["default"].createElement(Spacer["default"], null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: "h1",
    containerCustomStyle: {
      textAlign: 'center'
    }
  }, claimsOrderLookupTitle)), /*#__PURE__*/React__default["default"].createElement(Spacer["default"], null, /*#__PURE__*/React__default["default"].createElement(OrderNumberField["default"], {
    error: errors.orderNumber,
    value: values.orderNumber,
    onChange: onChange
  })), /*#__PURE__*/React__default["default"].createElement(EmailField["default"], {
    error: errors.email,
    value: values.email,
    onChange: onChange
  }), /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], null, claimsOrderLookupReasonDescription), /*#__PURE__*/React__default["default"].createElement(Spacer["default"], null, /*#__PURE__*/React__default["default"].createElement(ClaimReasonField["default"], {
    value: values.claimTypeOption,
    error: errors.claimTypeOption,
    onChange: onChange,
    logTitan: titan === null || titan === void 0 ? void 0 : titan.track,
    orderNumber: orderNumber
  })))))));
};
var OrderLookup$1 = nthHookTranslations.withTranslationsProvider(nthHookSettings.withSettingsProvider(OrderLookup, {
  settingsRequested: `
      claimTypeOptionActions {
        ItemMissing {
          actionType
          redirectUrl
        }
        ItemDamaged {
          actionType
          redirectUrl
        }
        PackageMissing {
          actionType
          redirectUrl
        }
        WrongItem {
          actionType
          redirectUrl
        }
      }
    `
}), {
  translationKeys: ['claimsButtonNext', 'claimsOrderLookupTitle', 'claimsOrderLookupLoading', 'claimsOrderLookupReasonDescription', 'claimsOrderLookupApiErrorOrderNotFound', 'claimsOrderLookupApiErrorUnknown']
});

exports["default"] = OrderLookup$1;
